import "./Style/Style.css";
import pic1 from "./Assits/vis.jpeg";
import pic3 from "./Assits/shu.jpeg";
import pic4 from "./Assits/avino.jpeg";
import pic5 from "./Assits/swech.jpeg";
import pic6 from "./Assits/sat.jpeg";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
// import 'swiper/css/Autoplay';

export default () => {
  return (
    <Swiper
      modules={[Autoplay, Pagination]}
      loop={true}
      spaceBetween={20}
      breakpoints={{
        0: { slidesPerView: 1 },
        648: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      }}
      centeredSlides={true}
      grabCursor={true}
      autoplay={{ delay: 2000 }}
      pagination={{ clickable: true }}
    >
      <SwiperSlide>
        <div className="swiper-slide box">
          <img src={pic1} alt="" />
          <div className="content">
            <h2>Vishnu Singh Rajput</h2>
            <h3>IIITDM Chennai</h3>
            <p>
              You don't need to see the entire staircase to take the first step;
              just keep moving forward, and the way will reveal itself
            </p>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper-slide box">
          <img src={pic6} alt="" />
          <div className="content">
            <h2>Satyam Rao</h2>
            <h3>IIITDM Chennai</h3>
            <p>
              The path you choose today determines the destination of your
              tomorrow.
            </p>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper-slide box">
          <img src={pic3} alt="" />
          <div className="content">
            <h2>Shudhanshu Singh</h2>
            <h3>IIt Patna</h3>
            <p>
              The difference between a successful person and others is not a
              lack of strength, not a lack of knowledge, but rather a lack in
              will.
            </p>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper-slide box">
          <img src={pic4} alt="" />
          <div className="content">
            <h2>Avino Joshi</h2>
            <h3>MNIT Allahabad</h3>
            <p>
              Education is the passport to the future, for tomorrow belongs to
              those who prepare for it today.
            </p>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper-slide box">
          <img src={pic5} alt="" />
          <div className="content">
            <h2>Swechchha Dubey</h2>
            <h3>LBSH Medical College</h3>
            <p>
              The only limit to our realization of tomorrow will be our doubts
              of today.
            </p>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper-slide box">
          <img src='https://t4.ftcdn.net/jpg/05/11/55/91/360_F_511559113_UTxNAE1EP40z1qZ8hIzGNrB0LwqwjruK.jpg' alt="" />
          <div className="content">
            <h2>Rahul Singh</h2>
            <h3>AIIMS Delhi</h3>
            <p>
              Every morning brings new potential, but if you dwell on the
              misfortunes of the day before, you tend to overlook tremendous
              opportunities.
            </p>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
  );
};
